export default class AboutUsService {
    constructor({ $axios }) {
        this.$axios = $axios;
    }

    /**
     * Get employees
     */
    async getEmployees(resetCache = false) {
        const config = {
            method: 'get',
            url: '/about-us/employees',
            params: {
                resetCache,
            },
        };

        const response = await this.$axios(config);

        return response.data.employees;
    }
}
